<template>
  <StoreLocatorPage />
</template>

<script setup lang="ts">
const { t } = useI18n();

definePageMeta({ layout: 'default' });
useHead({ title: t('storeLocator.pageTitle') });
</script>
